<template>
  <v-bottom-sheet
    v-model="isOffline"
    :hide-overlay="true"
    content-class="mx-0 my-0"
  >
    <div class="error white--text px-1 py-1 text-center">
      You are offline. Please check your network
    </div>
  </v-bottom-sheet>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import { State } from 'vuex-class'

@Component
export default class NetworkStatus extends Vue {

  isOffline: boolean = false

  created () {
    window.addEventListener('online',  this.updateOnlineStatus)
    window.addEventListener('offline', this.updateOfflineStatus)
  }

  updateOnlineStatus () {
    this.isOffline = false
  }

  updateOfflineStatus () {
    this.isOffline = true
  }
}
</script>
